import {MESSAGE_ROLES} from './config.js'

// TRACKING - Close net
export const getTrackingCloseNet = (tracking, chatData = {}) => {
  const {
    TRACKING_EVENT_NAMES: {NET_ASSISTANT_CLOSED} = {},
    HIT_ORIGINS: {NET_ASSISTANT_LANDING, NET_ASSISTANT_CONVERSATION} = {}
  } = tracking || {}

  const hasMessages = chatData.content && chatData.content.length > 0
  const hitOrigin = hasMessages ? NET_ASSISTANT_CONVERSATION : NET_ASSISTANT_LANDING

  return {
    event: NET_ASSISTANT_CLOSED,
    data: {
      hit_origin: hitOrigin,
      hit_information: chatData.chatId
    }
  }
}

// TRACKING - Answer clicked (show results button or ad card click)
export const getTrackingAnswerClicked = (tracking, chatData = {}, adId) => {
  const {
    TRACKING_EVENT_NAMES: {NET_ASSISTANT_ANSWER_CLICKED} = {},
    HIT_ORIGINS: {NET_ASSISTANT_AD, NET_ASSISTANT_LISTING} = {}
  } = tracking || {}

  const hitOrigin = adId ? NET_ASSISTANT_AD : NET_ASSISTANT_LISTING

  return {
    event: NET_ASSISTANT_ANSWER_CLICKED,
    data: {
      hit_origin: hitOrigin,
      hit_information: chatData.chatId,
      ...(adId && {ad_id: adId})
    }
  }
}

// TRACKING - Ad carousel impression
export const getTrackingAdImpressions = (tracking, chatId, products) => {
  const {TRACKING_EVENT_NAMES: {AD_IMPRESSIONS_COLLECTED_EVENT} = {}} = tracking || {}

  return {
    event: AD_IMPRESSIONS_COLLECTED_EVENT,
    data: {
      hit_information: chatId,
      products
    }
  }
}

// TRACKING - Message sent
export const getTrackingMessageSent = (tracking, chatData = {}, data = {}) => {
  const {TRACKING_EVENT_NAMES: {NET_ASSISTANT_MESSAGE_SENT} = {}} = tracking || {}

  // Steps of the converstation (the steps the user has taken - the messages the user has sent)
  const userMessages = !chatData.content ? 0 : chatData.content.filter(({role}) => role === MESSAGE_ROLES.USER)

  return {
    event: NET_ASSISTANT_MESSAGE_SENT,
    data: {
      hit_information: data.value,
      hit_information2: data.messageType,
      hit_information3: `${userMessages?.length}`,
      hit_information4: chatData.chatId
    }
  }
}

// TRACKING - New conversation started
export const getTrackingNewConversation = tracking => {
  const {TRACKING_EVENT_NAMES: {NET_ASSISTANT_NEW_CHAT_CLICKED} = {}, HIT_ORIGINS: {NET_ASSISTANT_NEW_CHAT} = {}} =
    tracking || {}

  return {
    event: NET_ASSISTANT_NEW_CHAT_CLICKED,
    data: {
      hit_origin: NET_ASSISTANT_NEW_CHAT
    }
  }
}

// TRACKING - Access old conversation from history
export const getTrackingAccessOldChat = (tracking, originChatId, selectedChatId) => {
  const {TRACKING_EVENT_NAMES: {NET_ASSISTANT_ACCESS_CLICKED} = {}, HIT_ORIGINS: {NET_ASSISTANT_OLD_CHAT} = {}} =
    tracking || {}

  return {
    event: NET_ASSISTANT_ACCESS_CLICKED,
    data: {
      hit_origin: NET_ASSISTANT_OLD_CHAT,
      hit_information: originChatId,
      hit_information2: selectedChatId
    }
  }
}

// TRACKING - Review sent
export const getTrackingReviewSent = (tracking, data) => {
  const {TRACKING_EVENT_NAMES: {NET_ASSISTANT_REVIEW_SENT} = {}} = tracking || {}
  const {chatId, messageId, type, step, ...rest} = data

  return {
    event: NET_ASSISTANT_REVIEW_SENT,
    data: {
      ...rest,
      hit_id: messageId,
      hit_information: chatId,
      hit_information2: `${step}`,
      hit_information3: type
    }
  }
}

// TRACKING - Menu (chat history) opened
export const getTrackingMenuClicked = (tracking, chatId) => {
  const {TRACKING_EVENT_NAMES: {NET_MENU_CLICKED} = {}} = tracking || {}

  return {
    event: NET_MENU_CLICKED,
    data: {
      hit_information: chatId
    }
  }
}

// TRACKING - Review detail sent
export const getTrackingReviewDetailSent = (tracking, data) => {
  const {TRACKING_EVENT_NAMES: {NET_ASSISTANT_REVIEW_DETAIL_SENT} = {}} = tracking || {}
  const {chatId, messageId, step, tags, text, ...rest} = data

  return {
    event: NET_ASSISTANT_REVIEW_DETAIL_SENT,
    data: {
      ...rest,
      hit_id: messageId,
      hit_information: chatId,
      hit_information2: `${step}`,
      hit_information3: tags,
      hit_information4: text
    }
  }
}
